import type { WReferenceLinkingToUrlContent } from "@/lib/api/cms-window-content";
import styles from "./WReferenceLinkingToUrlHeaderLink.module.css";

/**
 * WReferenceLinkingToUrlHeaderLink — area variant renderer dla `w_reference_linking_to_url`
 * uzywany w naglowku (headerCol) jako subtle text link (np. "Strefa klienta").
 *
 * Zarejestrowany w `windowVariants.areaOverrides.w_reference_linking_to_url.headerCol4`.
 */
export default function WReferenceLinkingToUrlHeaderLink({
  content,
}: WReferenceLinkingToUrlHeaderLinkProps) {
  if (!content) return null;
  const { title, config } = content;
  if (!title) return null;

  const label = <span dangerouslySetInnerHTML={{ __html: title }} />;

  return config.list_url ? (
    <a href={config.list_url} className={styles.link}>
      {label}
    </a>
  ) : (
    <span className={styles.link}>{label}</span>
  );
}

export type WReferenceLinkingToUrlHeaderLinkProps = {
  content: WReferenceLinkingToUrlContent | null;
};
